import { Component, OnInit } from '@angular/core';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { Course } from '../../../shared/models/interfaces/course.interface';
import { Track } from '../../../shared/models/interfaces/track.interface';
import { TrackService } from '../../../shared/services/track/track.service';
import { ToastService } from '../../../shared/components/toast/service/toast.service';
import { ActivatedRoute } from '@angular/router';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { CarouselComponent } from '../../../shared/components/carousel/carousel.component';
import { CourseLocation } from '../../../shared/models/enums/course-location.enum';
import { COURSE_LOCATION_ICONS } from '../../../shared/models/records/course-location.record';
import { CourseCardComponent } from '../../../shared/components/course-card/course-card.component';
import { CourseService } from '../../../shared/services/course/course.service';

@Component({
  selector: 'l-details',
  imports: [SpinnerComponent, IconComponent, CarouselComponent, CourseCardComponent],
  templateUrl: './details.component.html'
})
export class TrackDetailsComponent implements OnInit {

  //#region Constructor

  constructor(
    private readonly trackService: TrackService,
    private readonly courseService: CourseService,
    private readonly toastService: ToastService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.trackId = this.activatedRoute.snapshot.paramMap.get('trackId') ?? '';
  }

  //#endregion

  //#region Public Properties

  public isLoading: boolean = false;

  public isLoadingCourses: boolean = false;

  public courses: Course[] = [];

  public track?: Track;

  public trackId: string = '';

  public location: CourseLocation = CourseLocation.ONLINE;

  //#endregion

  //#region Getters

  public get locationIcon(): string {
    return COURSE_LOCATION_ICONS[this.location];
  }
    

  //#endregion

  //#region Public Methods

  public async ngOnInit(): Promise<void> {
    await this.loadTrack();
  }

  //#endregion

  //#region Private Methods

  private async loadTrack(): Promise<void> {
    try {
      this.isLoading = true;
      this.track = await this.trackService.getById(this.trackId);

      await this.loadCourses();
    } catch {
      this.toastService.error('Erro ao carregar trilha.', 'Oops...');
    } finally {
      this.isLoading = false;
    }
  }

  private async loadCourses(): Promise<void> {
    this.isLoadingCourses = true;

    try {
      const courseIds = [...new Set(this.track?.coursesIds ?? [])];

      if (!courseIds.length) {
        this.courses = [];
        this.getLocationFromCourses();
        return;
      }

      const courses = await this.courseService.search({
        search: { id: { $in: courseIds } },
        limit: Math.min(courseIds.length, 100),
      });
      const coursesById = new Map(courses.map(course => [course.id, course]));

      this.courses = courseIds
        .map(courseId => coursesById.get(courseId))
        .filter((course): course is Course => !!course);
      this.getLocationFromCourses();
    } catch {
      this.courses = [];
    } finally {
      this.isLoadingCourses = false;
    }
  }

  private getLocationFromCourses(): void {
    const hasPresential = this.courses.some(course => course.location === CourseLocation.PRESENTIAL);
    
    this.location = hasPresential ? CourseLocation.PRESENTIAL : CourseLocation.ONLINE;
  }

  //#endregion
}
